var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscoverIncentivesRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5002,
    cy: 18.0143,
    r: 11.6667,
    fill: "#E14227"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0448 14.133C17.3053 10.753 15.2763 14.0274 15.6094 15.8382C15.9426 17.6489 18.123 17.9809 19.0467 18.1167C25.5729 19.0522 21.2271 26.7177 14.7463 21.9343",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5015 10.7227V12.5031",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5015 23.4429V25.8119",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9258 29.66C31.5973 30.0487 31.2551 30.4272 30.8993 30.7954C25.6584 36.1132 17.5995 37.511 10.8639 34.2706C4.12825 31.0301 0.21407 23.8722 1.13276 16.4751",
    stroke: "#E14227",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.07397 7.3404C5.40243 6.95171 5.74458 6.57324 6.10041 6.20501C11.3413 0.887228 19.4002 -0.510601 26.1358 2.72983C32.8715 5.97026 36.7857 13.1282 35.867 20.5253",
    stroke: "#E14227",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12988 8.27125V4.17969L8.29162 8.27125H4.12988Z",
    fill: "#E14227",
    stroke: "#E14227",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0835 28.4856L33.0835 32.5771L28.9218 28.4856L33.0835 28.4856Z",
    fill: "#E14227",
    stroke: "#E14227",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverIncentivesRed);
export default __webpack_public_path__ + "static/media/discover-incentives-red.ffc4cbeed6822dc3b8f6cb022610ae53.svg";
export { ForwardRef as ReactComponent };